import { render, staticRenderFns } from "./EditLegal.vue?vue&type=template&id=118bf035&"
import script from "./EditLegal.vue?vue&type=script&lang=js&"
export * from "./EditLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports